// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Bill Drawer ===== */

.od-drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 1555;
  background: rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.od-bill-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  width: 92vw;
  max-width: 560px;
  background: #f3efe7;
  border-right: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 28px 0 90px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.od-bill-drawer--open {
  transform: translateX(0);
}

.od-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  background: #f3efe7;
  flex-shrink: 0;
}

.od-drawer-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.od-drawer-label {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  margin: 0;
}

.od-drawer-id {
  font-size: 13px;
  font-weight: 600;
  color: #2a71ff;
  margin: 0;
}

.od-drawer-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.bill-layout-template-section {
  margin-left: auto;
  margin-right: auto;
  max-width: 440px;
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
}

/* ===== Drawer Close Button ===== */

.od-drawer-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
}

.od-drawer-close-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
}

/* ── Dark mode ── */
.dark .od-bill-drawer {
  background: #1e293b;
  border-right-color: #334155;
}

.dark .od-drawer-header {
  background: #1e293b;
  border-bottom-color: #334155;
}

.dark .od-drawer-label {
  color: #94a3b8;
}

.dark .od-drawer-close-btn {
  background: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}

.dark .od-drawer-close-btn:hover {
  background: #1e293b;
  border-color: #475569;
  color: #f1f5f9;
}

/* Keep the bill paper itself white/warm — it represents a printed receipt */
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/OrdersV2/Component/BillDrawer.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA,oCAAoC;;AAEpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd;;;eAGa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4EAA4E","sourcesContent":["/* ===== Bill Drawer ===== */\n\n.od-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1555;\n  background: rgba(15, 23, 42, 0.35);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.od-bill-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  width: 92vw;\n  max-width: 560px;\n  background: #f3efe7;\n  border-right: 1px solid rgba(226, 232, 240, 0.8);\n  box-shadow: 28px 0 90px rgba(15, 23, 42, 0.22);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.od-bill-drawer--open {\n  transform: translateX(0);\n}\n\n.od-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  background: #f3efe7;\n  flex-shrink: 0;\n}\n\n.od-drawer-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.od-drawer-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n  margin: 0;\n}\n\n.od-drawer-id {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2a71ff;\n  margin: 0;\n}\n\n.od-drawer-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.bill-layout-template-section {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 440px;\n  border-radius: 28px;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  background: #ffffff;\n  padding: 24px;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);\n}\n\n/* ===== Drawer Close Button ===== */\n\n.od-drawer-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n}\n\n.od-drawer-close-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n/* ── Dark mode ── */\n.dark .od-bill-drawer {\n  background: #1e293b;\n  border-right-color: #334155;\n}\n\n.dark .od-drawer-header {\n  background: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .od-drawer-label {\n  color: #94a3b8;\n}\n\n.dark .od-drawer-close-btn {\n  background: #0f172a;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .od-drawer-close-btn:hover {\n  background: #1e293b;\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n/* Keep the bill paper itself white/warm — it represents a printed receipt */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
